import { render, staticRenderFns } from "./TaskEditModal.vue?vue&type=template&id=d9a46d06"
import script from "./TaskEditModal.vue?vue&type=script&lang=ts"
export * from "./TaskEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9a46d06')) {
      api.createRecord('d9a46d06', component.options)
    } else {
      api.reload('d9a46d06', component.options)
    }
    module.hot.accept("./TaskEditModal.vue?vue&type=template&id=d9a46d06", function () {
      api.rerender('d9a46d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskEditModal.vue"
export default component.exports